<template>
  <v-layout wrap :id="taxId">
    <v-flex class="xs6 md4 pa-2">
      <v-text-field
        v-model="tax.attributes.name"
        label="Name"
        placeholder="Tax Name"
        name="name"
        required
      />
    </v-flex>

    <v-flex class="xs1 md1 pa-2 valign-wrapper">
      <div class="fa fa-chevron-right light" />
    </v-flex>

    <v-flex class="xs4 md2 pa-2">
      <v-text-field
        v-model="tax.attributes.percent"
        label="Add Percent"
        type="number"
        min="0.00"
        step="0.01"
        placeholder="0"
      />
    </v-flex>

    <v-flex class="xs2 md1 pa-2 valign-wrapper offset-md4">
      <div class="btn-blank btn-flat btn-small btn-reorder-taxes">
        <div class="fa fa-exchange rotate90" />
      </div>
      <div class="btn-blank btn-flat btn-small danger" @click="deleteTax">
        <div class="fa fa-trash" />
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { debounce } from 'lodash'

export default {
  computed: {
    taxId() {
      return `tax-${this.tax.id}`
    },
  },
  methods: {
    deleteTax() {
      this.$store.dispatch('services/deleteTax', this.tax.id)
    },
  },
  watch: {
    tax: {
      handler: debounce(function (newVal) {
        this.$store.dispatch('services/updateServiceTax', newVal)
      }, 500),
      deep: true,
    },
  },
  props: ['tax'],
}
</script>

<style>
.btn-reorder-taxes {
  cursor: move;
}
</style>
